const strings = {
  labels: {
    clearSearch: 'Clear Search',
  },
  errors: {
    searchError: 'Customer search failed',
  },
  placeholders: {
    phone: '(314) 333-3333',
    name: 'Search Name',
    street: 'Search Address',
    unit: 'Unit',
    zip: 'Zip',
  },
  warnings: {
    systemCustomerNotFound: "We couldn't locate a record for this phone number",
  },
} as const;

export default strings;
